import {useQuery, useQueryClient} from '@tanstack/react-query';
import {fetchTiers, TIER_QUERY_KEY} from '@/services/ClubPlus/TierService';

export const useActiveTiers = () => {
  const queryClient = useQueryClient();

  const tiersQuery = useQuery({
    queryKey: [TIER_QUERY_KEY.ACTIVE_TIERS],
    queryFn: () => fetchTiers('active=true')
  });

  const invalidateTiersQuery = () => {
    queryClient.invalidateQueries({queryKey: [TIER_QUERY_KEY.ACTIVE_TIERS]});
  };

  return {
    tiers: tiersQuery.data,
    invalidateTiers: invalidateTiersQuery,
    isLoadingTiers: tiersQuery.isLoading,
    errorTiers: tiersQuery.error
  };
};
